module.exports = __webpack_public_path__ + "img/ch18_06_夕阳玩偶.ff2a0e40.jpg";